import { useState } from 'react'
import { api } from 'lib/axios'

const DocumentStatusChange = async payload => {
  const response = await api.post(
    '/Api/V8/custom/customer/set-doc-status-change',
    payload
  )
  return response
}

export const useDocumentStatusChange = () => {
  const [
    isDocumentStatusChangeDataLoading,
    setIsDocumentStatusChangeDataLoading
  ] = useState(false)

  const handleDocumentStatusChange = async payload => {
    setIsDocumentStatusChangeDataLoading(true)
    try {
      const response = await DocumentStatusChange(payload)
      if (response) {
        return response
      } else {
        console.error('Document Status Change failed:', response)
        return null
      }
    } catch (error) {
      console.error('Document Status Change failed:', error)
    } finally {
      setIsDocumentStatusChangeDataLoading(false)
    }
  }

  return {
    isDocumentStatusChangeDataLoading,
    handleDocumentStatusChange
  }
}
